import { LabelValuePair } from "models/label-value";

export const CountryCodes: LabelValuePair[] = [
    { label: "Sri Lanka (+94)", value: "+94" },
    { label: "United States (+1)", value: "+1" },
    { label: "United Kingdom (+44)", value: "+44" },
    { label: "Australia (+61)", value: "+61" },
    // Add more countries as needed
];